export function convertHoursOfOperation(input) {
  const daysMap = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  function formatTime(time) {
      let hour = parseInt(time.substring(0, 2), 10);
      let minute = time.substring(2);
      let period = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12; // Convert to 12-hour format, making 0 -> 12
      return `${hour}:${minute} ${period}`;
  }

  function formatPeriod(open, close) {
      let formattedOpen = formatTime(open);
      let formattedClose = formatTime(close);

      return `${formattedOpen} - ${formattedClose}`;
  }

  const result = {};

  Object.entries(input).forEach(([_day, periods], index) => {
      if (periods.length === 0) {
          result[daysMap[index]] = ["Closed"];
      } else {
          result[daysMap[index]] = periods.map(p => formatPeriod(p.open, p.close));
      }
  });

  return result;
}

export function getDayOfTheWeek() {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[dayOfWeek];
}

export function isOpenNow(schedule) {
  const now = new Date();
  const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const dayOfWeek = daysOfWeek[new Date().getDay()];
  const currentTime = now.getHours() * 100 + now.getMinutes();

  let hours;
  try { // shortcut. TODO: look for the real bug and dive deeper.
    hours = schedule[dayOfWeek] || [];
  } catch (e) {
    console.log(e);
    return false;
  }

  return hours.some(({ open, close }) => currentTime >= parseInt(open) && currentTime <= parseInt(close));
}
